interface SetupHeaderProps {
    onClick: () => void;
    handleClickNew: () => void;
    selectedSetupName: string | undefined;
}

export default function SetupHeader({ onClick, handleClickNew, selectedSetupName }: SetupHeaderProps) {
    return (
        <div className="flex justify-between items-center">
            <button
                type="button"
                onClick={onClick}
                className="h-7 items-center gap-2 rounded border border-gray-300 bg-white px-3  text-xs font-medium text-gray-700 transition-colors hover:bg-gray-100"
            >
                ← Back
            </button>
            <button type="button" className="cursor-default h-7 items-center gap-2 rounded bg-white px-3 text-sm font-semibold text-gray-700 transition-colors">
                {selectedSetupName}
            </button>
            <button onClick={handleClickNew} type="button" className="h-7 bg-blue-600  items-center gap-2 rounded border border-gray-300 font-medium px-3  text-xs text-white transition-colors hover:bg-blue-700">
                {'Add new'}
            </button>
        </div>
    )
}
